<template>
  <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M0 0h20v1H0zm0 7h20v1H0zm0 7h20v1H0z" />
  </svg>
</template>
